import React from "react";

// reactstrap components
import { Row, Container, Col } from "reactstrap";

function DemoFooter() {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      padding: '80px 0 40px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Animated Background Elements */}
      <div style={{
        position: 'absolute',
        top: '-50px',
        right: '-50px',
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 8s ease-in-out infinite'
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '-100px',
        left: '-100px',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(240, 147, 251, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 10s ease-in-out infinite 2s'
      }}></div>

      {/* Floating Icons */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '10%',
        animation: 'bounce 3s infinite'
      }}>
        <i className="fa fa-heart" style={{ 
          fontSize: '30px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite'
        }} />
      </div>
      
      <div style={{
        position: 'absolute',
        top: '30%',
        right: '15%',
        animation: 'bounce 3s infinite 1s'
      }}>
        <i className="fa fa-star" style={{ 
          fontSize: '25px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite 0.5s'
        }} />
      </div>

      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row>
          <Col md="4" style={{ marginBottom: '40px' }}>
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '20px',
              padding: '40px 30px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              height: '100%'
            }}>
              <h4 style={{
                color: 'white',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '20px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Tri-Advise
              </h4>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.1rem',
                lineHeight: '1.6',
                marginBottom: '30px',
                textShadow: '0 1px 2px rgba(0,0,0,0.3)'
              }}>
                Building Better Brands through innovative digital marketing solutions. 
                We transform businesses and create exceptional experiences that drive growth and success.
              </p>
              <div style={{ display: 'flex', gap: '15px' }}>
                <a 
                  href="https://www.facebook.com/TriAdvise/" 
                  target="_blank"
                  style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    padding: '10px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = 'white';
                    e.target.style.background = 'rgba(59, 89, 152, 0.3)';
                    e.target.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255,255,255,0.8)';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <i className="fa fa-facebook-square" />
                </a>
                <a 
                  href="https://www.instagram.com/tri_advise/" 
                  target="_blank"
                  style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    padding: '10px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = 'white';
                    e.target.style.background = 'rgba(225, 48, 108, 0.3)';
                    e.target.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255,255,255,0.8)';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <i className="fa fa-instagram" />
                </a>
                <a 
                  href="https://www.linkedin.com/company/tri-advise/" 
                  target="_blank"
                  style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    padding: '10px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = 'white';
                    e.target.style.background = 'rgba(0, 119, 181, 0.3)';
                    e.target.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255,255,255,0.8)';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <i className="fa fa-linkedin" />
                </a>
                <a 
                  href="https://wa.me/+96181906656" 
                  target="_blank"
                  style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    padding: '10px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = 'white';
                    e.target.style.background = 'rgba(37, 211, 102, 0.3)';
                    e.target.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255,255,255,0.8)';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <i className="fa fa-whatsapp" />
                </a>
              </div>
            </div>
          </Col>

          <Col md="4" style={{ marginBottom: '40px' }}>
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '20px',
              padding: '40px 30px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              height: '100%'
            }}>
              <h4 style={{
                color: 'white',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '30px',
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Quick Links
              </h4>
              <nav className="footer-nav">
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: '15px' }}>
                    <a 
                      style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      href="/"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#feca57';
                        e.target.style.transform = 'translateX(10px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >
                      <i className="fa fa-home" style={{ marginRight: '10px', width: '20px' }} />
                      Home
                    </a>
                  </li>
                  <li style={{ marginBottom: '15px' }}>
                    <a 
                      style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      href="/nfc"
                      target="_blank"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#feca57';
                        e.target.style.transform = 'translateX(10px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >
                      <i className="nc-icon nc-credit-card" style={{ marginRight: '10px', width: '20px' }} />
                      NFC Card
                    </a>
                  </li>
                  <li style={{ marginBottom: '15px' }}>
                    <a 
                      style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      href="/course"
                      target="_blank"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#feca57';
                        e.target.style.transform = 'translateX(10px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >
                      <i className="nc-icon nc-book-bookmark" style={{ marginRight: '10px', width: '20px' }} />
                      Courses
                    </a>
                  </li>
                  <li style={{ marginBottom: '15px' }}>
                    <a 
                      style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      href="/services"
                      target="_blank"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#feca57';
                        e.target.style.transform = 'translateX(10px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >
                      <i className="nc-icon nc-layout-11" style={{ marginRight: '10px', width: '20px' }} />
                      Services
                    </a>
                  </li>
                  <li style={{ marginBottom: '15px' }}>
                    <a 
                      style={{ 
                        color: 'rgba(255,255,255,0.9)',
                        textDecoration: 'none',
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      href="/contact"
                      target="_blank"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#feca57';
                        e.target.style.transform = 'translateX(10px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'translateX(0)';
                      }}
                    >
                      <i className="fa fa-envelope" style={{ marginRight: '10px', width: '20px' }} />
                      Contact
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </Col>

          <Col md="4" style={{ marginBottom: '40px' }}>
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '20px',
              padding: '40px 30px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              height: '100%'
            }}>
              <h4 style={{
                color: 'white',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '30px',
                background: 'linear-gradient(45deg, #f093fb, #f5576c)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Contact Info
              </h4>
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <i className="fa fa-phone" style={{ 
                    color: '#feca57', 
                    marginRight: '15px',
                    fontSize: '1.2rem'
                  }} />
                  <span style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '1.1rem',
                    fontWeight: '500'
                  }}>
                    +961 81 906 656
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <i className="fa fa-envelope" style={{ 
                    color: '#feca57', 
                    marginRight: '15px',
                    fontSize: '1.2rem'
                  }} />
                  <span style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '1.1rem',
                    fontWeight: '500'
                  }}>
                    info@tri-advise.com
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <i className="fa fa-map-marker" style={{ 
                    color: '#feca57', 
                    marginRight: '15px',
                    fontSize: '1.2rem'
                  }} />
                  <span style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '1.1rem',
                    fontWeight: '500'
                  }}>
                    Lebanon, Beirut
                  </span>
                </div>
              </div>
              
              <div style={{
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '15px',
                padding: '20px',
                border: '1px solid rgba(255,255,255,0.1)',
                marginTop: '20px'
              }}>
                <h5 style={{
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  Ready to Get Started?
                </h5>
                <p style={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '1rem',
                  marginBottom: '20px'
                }}>
                  Let's discuss your project and bring your vision to life.
                </p>
                <a 
                  href="/contact"
                  target="_blank"
                  style={{
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    color: 'white',
                    padding: '12px 24px',
                    borderRadius: '25px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: '1rem',
                    display: 'inline-block',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 107, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 107, 0.3)';
                  }}
                >
                  <i className="fa fa-rocket" style={{ marginRight: '8px' }} />
                  Contact Us
                </a>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row>
          <Col md="12">
            <div style={{
              textAlign: 'center',
              padding: '30px 0',
              borderTop: '1px solid rgba(255,255,255,0.1)',
              marginTop: '20px'
            }}>
              <span style={{ 
                color: 'rgba(255,255,255,0.8)', 
                fontSize: '1.1rem',
                fontWeight: '500'
              }}>
                © {new Date().getFullYear()}, Made with{" "}
                <i className="fa fa-heart" style={{ color: '#ff6b6b' }} /> by Tri-Advise
              </span>
            </div>
          </Col>
        </Row>
      </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-15px); }
          60% { transform: translateY(-7px); }
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
    </footer>
  );
}

export default DemoFooter;